export const IMAGE_HEIGHT = 148;
